import { Component } from 'react';
import {connect} from 'react-redux';
import {getRetailerNews} from '../../../actions/latest-news';
import NewsPage from '../../common/news-page/news-page';

class RdrNewsPage extends Component {
  pageSlug = 'retailer-news';

  UNSAFE_componentWillMount() {
    const {dispatch} = this.props;
    dispatch(getRetailerNews());
  }

  render() {
    const {retailerNews, loading} = this.props;

    return loading ? <div>Loading...</div> : (
      <NewsPage
        title="Retailer News"
        className={this.pageSlug}
        slug={this.pageSlug}
        articles={retailerNews}
        loading={loading}
      />
    );
  }
}

const mapStateToProps = state => ({
  retailerNews: state.latestNews.retailerNews,
  loading: state.latestNews.fetching && !state.latestNews.fetched,
});

export default connect(mapStateToProps)(RdrNewsPage);
